import React from "react";

const EnterpriseSecurityLayout = () => {
    return (
        <div className="bg-white">

            {/* ================= HERO ================= */}
            <section
                className="relative h-[520px] flex items-center text-white"
                style={{
                    backgroundImage:
                        "linear-gradient(rgba(5,10,20,.85), rgba(5,10,20,.85)), url(/images/enterprisesecurity/hero.jpg)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="relative w-full px-6 md:px-16 lg:px-24 py-24 text-white text-left">
                    <span className="uppercase text-sm tracking-wide text-orange-400">
                        Services
                    </span>
                    <h1 className="text-4xl md:text-5xl font-bold mt-3 mb-4">
                        Enterprise IT Security
                    </h1>
                    <p className="max-w-2xl text-lg text-gray-200 mb-6">
                        Delivering resilient, intelligent, and scalable enterprise security
                        solutions to protect critical systems and data.
                    </p>
                    <button className="bg-orange-500 hover:bg-orange-600 px-6 py-3 rounded-md font-semibold">
                        Consult Our Experts
                    </button>
                </div>
            </section>

            {/* ================= FEATURED INSIGHT ================= */}
            <section className="py-14 border-b">
                <div className="max-w-7xl mx-auto px-6">
                    <p className="text-sm text-orange-600 font-medium mb-2">
                        Featured Insight
                    </p>
                    <p className="text-lg font-semibold text-gray-800">
                        Data Privacy in the Modern Enterprise: What Every Leader Must Know →
                    </p>
                </div>
            </section>

            {/* ================= SECURITY STRATEGY ================= */}
            <section className="py-20">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-10">

                    <div className="md:col-span-2">
                        <h2 className="text-3xl font-bold mb-4">
                            Cyber Resilience Strategy
                        </h2>
                        <p className="text-gray-600 mb-6">
                            Protect your organization from advanced cyber threats by combining
                            people, processes, and technology into a unified security posture.
                        </p>
                        <button className="bg-orange-500 text-white px-6 py-3 rounded-md">
                            Learn more about our offerings
                        </button>
                    </div>

                    <div className="bg-[#020617] text-white p-6 rounded-xl">
                        <h4 className="font-semibold mb-4">Our Offerings</h4>
                        <ul className="text-sm space-y-2 text-gray-300">
                            <li>• Security Risk Assessment</li>
                            <li>• Identity & Access Management</li>
                            <li>• Cloud Security</li>
                            <li>• Zero Trust Architecture</li>
                        </ul>
                    </div>

                </div>
            </section>

            {/* ================= RANSOMWARE ================= */}
            <section
                className="py-24 text-white"
                style={{
                    backgroundImage:
                        "linear-gradient(rgba(10,10,20,.85), rgba(10,10,20,.85)), url(https://images.unsplash.com/photo-1633265486064-086b219458ec)",
                    backgroundSize: "cover",
                }}
            >
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-4">
                        Ransomware Attacks Are Inevitable
                    </h2>
                    <p className="max-w-xl text-gray-300 mb-6">
                        Ensure safe, secure, and accelerated recovery with modern cyber
                        resilience frameworks.
                    </p>
                    <button className="border border-white px-6 py-3 rounded-md">
                        Learn more
                    </button>
                </div>
            </section>

            {/* ================= CLIENT SUCCESS ================= */}
            <section className="py-20 bg-[#020617] text-white">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-10">Client Success</h2>

                    <div className="grid md:grid-cols-3 gap-8">
                        {[
                            {
                                img: "https://images.unsplash.com/photo-1555949963-aa79dcee981c",
                                title: "Improving IAM efficiency for a global enterprise",
                                cta: "Read the story →",
                            },
                            {
                                img: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4",
                                title: "Reducing security risk through platform modernization",
                                cta: "View case study →",
                            },
                            {
                                img: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d",
                                title: "Enhancing compliance and operational resilience",
                                cta: "Explore success →",
                            },
                        ].map((item, i) => (
                            <div
                                key={i}
                                className="bg-white text-black rounded-xl overflow-hidden"
                            >
                                <img
                                    src={item.img}
                                    alt={item.title}
                                    className="w-full h-48 object-cover"
                                    loading="lazy"
                                />

                                <div className="p-5">
                                    <h4 className="font-semibold mb-2 text-lg">
                                        {item.title}
                                    </h4>

                                    <button className="text-orange-500 font-semibold">
                                        {item.cta}
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>


            {/* ================= WHY US ================= */}
            <section className="py-20 bg-[#fde7d9]">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-8">
                    {[
                        {
                            title: "Secure, Scalable, Resilient",
                            text: "Enterprise-grade security architectures designed for growth.",
                        },
                        {
                            title: "Deep Security Expertise",
                            text: "Decades of experience across industries and platforms.",
                        },
                        {
                            title: "Partner Ecosystem",
                            text: "Strong alliances with leading cybersecurity providers.",
                        },
                    ].map((item) => (
                        <div key={item.title}>
                            <h4 className="font-semibold mb-2">{item.title}</h4>
                            <p className="text-sm text-gray-700">{item.text}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* ================= PARTNERS ================= */}
            <section className="py-16 border-b">
                <div className="max-w-7xl mx-auto px-6">
                    <h3 className="text-2xl font-bold mb-6">
                        Learn About Our Key Partners
                    </h3>
                    <div className="flex flex-wrap gap-8 items-center">
                        {["IBM", "Microsoft", "AWS", "Palo Alto", "Okta"].map((p) => (
                            <span
                                key={p}
                                className="text-gray-500 font-semibold text-lg"
                            >
                                {p}
                            </span>
                        ))}
                    </div>
                </div>
            </section>

            {/* ================= NEWS ================= */}
            {/* <section className="py-20 bg-[#020617] text-white">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-10">News & Insights</h2>
                    <div className="grid md:grid-cols-3 gap-8">
                        {[1, 2, 3].map((i) => (
                            <div key={i} className="bg-white text-black rounded-xl p-5">
                                <h4 className="font-semibold mb-2">
                                    Strengthening Enterprise Cyber Resilience
                                </h4>
                                <button className="text-orange-500 font-semibold">
                                    Read the blog →
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </section> */}

            {/* ================= CONTACT ================= */}
            {/* <section className="py-20">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-8">Contact Us</h2>
                    <form className="grid md:grid-cols-2 gap-6">
                        <input className="border p-3 rounded" placeholder="First name" />
                        <input className="border p-3 rounded" placeholder="Last name" />
                        <input className="border p-3 rounded" placeholder="Work email" />
                        <input className="border p-3 rounded" placeholder="Company" />
                        <textarea
                            className="border p-3 rounded md:col-span-2"
                            placeholder="How can we help?"
                            rows="4"
                        />
                        <button className="bg-orange-500 text-white px-6 py-3 rounded-md font-semibold">
                            Submit
                        </button>
                    </form>
                </div>
            </section> */}

        </div>
    );
};

export default EnterpriseSecurityLayout;
